import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import AKInlineDialog from '@atlaskit/inline-dialog';
import React, { PureComponent } from 'react';

/**
 * A wrapper over Atlaskit's Inline dialog component that
 * functions like a tooltip, i.e. is invoked on hover
 * https://atlaskit.atlassian.com/packages/core/inline-dialog
 */
export var RichTooltipContainer = _styled("span", {
  target: "e57v6ak0",
  label: "RichTooltipContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1c3h18e",
  styles: "flex:1 0 auto;"
} : {
  name: "1c3h18e",
  styles: "flex:1 0 auto;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var RICH_TOOLTIP_CLASS = 'rich_tooltip__container';

var RichTooltip = /*#__PURE__*/function (_PureComponent) {
  _inherits(RichTooltip, _PureComponent);

  var _super = _createSuper(RichTooltip);

  function RichTooltip() {
    var _this;

    _classCallCheck(this, RichTooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "showTimerId", void 0);

    _defineProperty(_assertThisInitialized(_this), "hideTimerId", void 0);

    _defineProperty(_assertThisInitialized(_this), "isFocused", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocusChange", function (e) {
      var isTooltipChild = function isTooltipChild(target) {
        return !(target instanceof HTMLElement) || !target.closest(".".concat(RICH_TOOLTIP_CLASS));
      };

      if (isTooltipChild(e.target)) {
        _this.isFocused = false;

        _this.setState({
          isOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      clearTimeout(_this.hideTimerId);
      _this.showTimerId = setTimeout(function () {
        _this.setState({
          isOpen: true
        });
      }, _this.props.delay);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      if (_this.isFocused) return;
      clearTimeout(_this.showTimerId); // Add a delay, allowing some time for the cursor to
      // hop onto the tooltip area without close being triggered

      _this.hideTimerId = setTimeout(function () {
        _this.setState({
          isOpen: false
        });
      }, 150);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      _this.isFocused = true;

      _this.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleContentBlur", function () {
      _this.isFocused = false;

      _this.setState({
        isOpen: false
      });
    });

    return _this;
  }

  _createClass(RichTooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('focus', this.handleFocusChange, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('focus', this.handleFocusChange, true);
    }
  }, {
    key: "render",
    value: function render() {
      var isOpen = this.state.isOpen;
      var _this$props = this.props,
          children = _this$props.children,
          content = _this$props.content;
      return /*#__PURE__*/React.createElement(RichTooltipContainer, {
        className: RICH_TOOLTIP_CLASS,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, /*#__PURE__*/React.createElement(AKInlineDialog, {
        content: content,
        isOpen: isOpen,
        onClose: this.handleContentBlur,
        onContentBlur: this.handleContentBlur
      }, /*#__PURE__*/React.createElement("span", {
        tabIndex: 0,
        onFocus: this.handleFocus,
        role: "tooltip"
      }, children)));
    }
  }]);

  return RichTooltip;
}(PureComponent);

_defineProperty(RichTooltip, "defaultProps", {
  delay: 200
});

export { RichTooltip as default };